import React from "react";

import { Box, Stack, Typography } from "@mui/material";

const SliderHeading = () => {
  return (
    <Stack flexGrow={1} direction="row" justifyContent="flex-end">
      <Typography
        variant="labelMed"
        sx={{ textAlign: "center", width: "168px", whitespace: "nowrap" }}
      >
        Who can view
      </Typography>
      <Box sx={{ width: "65px" }} />
      <Typography
        variant="labelMed"
        sx={{ textAlign: "center", width: "180px", whitespace: "nowrap" }}
      >
        Who can edit this setting
      </Typography>
    </Stack>
  );
};

export default SliderHeading;
